import { Component, EventEmitter, Input, Output } from '@angular/core';
import { PeopleService, SessionDetectService } from '../../../../../app/shared/services';
import { InspectionPlugin, InspectionSession } from '../../../../../app/shared/models';
import { BasePluginMenuComponent } from '../../../../menus';

@Component({
  templateUrl: 'edit-modal-header.component.html',
  selector: 'modal-header',
  standalone: false
})
export class EditModalHeaderComponent {
  @Input() ys: any;
  @Input() plugin: InspectionPlugin;
  @Input() menuModal: any;
  @Input() menuComponent: any;
  @Input() isEditPage: boolean = true;
  @Input() headerOptions: any = [];
  @Input() preventDefault: boolean = false;
  @Input() pluginType: string = null;
  @Input() enableSearch: boolean = false;

  @Input() query: string = '';
  @Output() queryChange: EventEmitter<string> = new EventEmitter<string>();
  public get queryString() {
    return this.query;
  }

  public set queryString(value) {
    this.queryChange.emit(value);
  }

  public currentPerson: any;
  public showSearch: boolean;

  @Output() public menuClick: EventEmitter<any> = new EventEmitter();
  constructor(private peopleService: PeopleService, private sessionDetect: SessionDetectService) {
    this.peopleService.getCurrent().subscribe((res) => (this.currentPerson = res));
  }
  public openMenu() {
    this.menuClick.emit();
    if (!this.preventDefault) {
      this.menuModal.modalFooter = false;
      this.menuModal.modalHeader = false;
      this.menuModal.modalMessage = false;
      this.menuModal.open(this.menuComponent || BasePluginMenuComponent, {
        plugin: this.plugin,
        inspection: this.plugin.inspection
      });
    }
  }

  public updateShowSearch(show: boolean = true) {
    this.showSearch = show;
    if (!this.showSearch) {
      this.query = '';
      this.queryChange.emit(this.query);
    }
  }

  public get isConnection() {
    return !!navigator.onLine;
  }

  public showMenuButton() {
    return !!this.menuComponent || !this.plugin?.inspection?.isOffline || (this.currentPerson?.isHost && this.isConnection);
  }

  navigateToSession(session: InspectionSession) {
    this.sessionDetect.navigate(session);
  }
}
